<script>
import { faqs } from '@site/data/seo'

export default {
  name: 'FaqSection',
  data() {
    return { faqs }
  },
}
</script>

<template>
  <section class="section section--light faq-section" id="faq">
    <div class="container">
      <div class="section-head reveal">
        <span class="section-eyebrow">常见问题</span>
        <h2>关于航富通，你想了解的</h2>
        <p>以下是我们被问到最多的问题，直接为你解答</p>
      </div>

      <div class="faq-list">
        <details class="faq-item reveal" v-for="(f, i) in faqs" :key="i">
          <summary class="faq-item__question">
            <span>{{ f.question }}</span>
            <span class="faq-item__icon" aria-hidden="true">+</span>
          </summary>
          <div class="faq-item__answer">
            <p>{{ f.answer }}</p>
          </div>
        </details>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.faq-section { padding: $space-section 0; }

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 820px;
  margin: 0 auto;
}

.faq-item {
  background: $color-bg-white;
  border: 1px solid rgba(29, 29, 31, 0.05);
  border-radius: $radius-md;
  box-shadow: $shadow-sm;
  overflow: hidden;

  &__question {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 22px 28px;
    cursor: pointer;
    font-size: 17px;
    font-weight: $weight-semibold;
    color: $color-text;
    list-style: none;
    transition: color $motion-fast;

    &::-webkit-details-marker { display: none; }
    &:hover { color: $color-primary; }
  }

  &__icon {
    flex-shrink: 0;
    font-size: 24px;
    font-weight: $weight-bold;
    color: $color-primary;
    transition: transform $motion-base $ease-out;
  }

  &__answer {
    padding: 0 28px 24px;
    color: $color-text-muted;
    line-height: 1.8;
    font-size: 15px;

    p { margin: 0; }
  }

  &[open] {
    border-color: $color-primary-tint;
    .faq-item__icon { transform: rotate(45deg); }
  }
}

@media (max-width: $bp-sm) {
  .faq-section { padding: 64px 0; }
  .faq-item__question { font-size: 16px; padding: 18px 20px; }
  .faq-item__answer { padding: 0 20px 20px; }
}
</style>



// WEBPACK FOOTER //
// src/site/components/home/FaqSection.vue